<template>
  <div id="app" class="min-h-screen bg-gray-50">
    <div v-if="loading" class="flex items-center justify-center h-screen">
      <div class="text-gray-500 text-lg">Loading...</div>
    </div>
    <div v-else-if="error" class="flex items-center justify-center h-screen">
      <div class="text-red-600 text-lg">{{ error }}</div>
    </div>
    <OpsFlowApp
      v-else
      :locationId="locationId"
      :companyId="companyId"
      :userName="userName"
    />
  </div>
</template>

<script>
import OpsFlowApp from './components/OpsFlowApp.vue'

export default {
  name: 'App',
  components: {
    OpsFlowApp
  },
  data() {
    return {
      locationId: null,
      companyId: null,
      userName: null,
      loading: true,
      error: null
    }
  },
  async mounted() {
    try {
      const data = await this.getUserDataWithTimeout(5000);
      console.log("user-details", data);
      this.locationId = data.activeLocation || data.locationId || null;
      this.companyId = data.companyId || null;
      this.userName = [data.firstName, data.lastName].filter(Boolean).join(' ') || data.email || data.userId || null;
    } catch (e) {
      console.warn("SSO timed out or failed, checking URL params:", e.message);
      const params = new URLSearchParams(window.location.search);
      this.locationId = params.get('locationId');
      this.companyId = params.get('companyId');
    }
    if (!this.locationId) {
      this.error = "No location ID found. When running standalone, add ?locationId=...&companyId=... to the URL.";
    }
    this.loading = false;
  },
  methods: {
    getUserDataWithTimeout(ms) {
      return Promise.race([
        window.ghl.getUserData(),
        new Promise((_, reject) =>
          setTimeout(() => reject(new Error('SSO timeout')), ms)
        )
      ]);
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
